module.exports = __webpack_public_path__ + "static/media/email_icon.ebbb6d67.svg";